import React, { createContext, useContext, useState, useEffect } from "react";

const BillingContext = createContext(null);
const KEY = "billone_cart_state";

const EMPTY = { cart: [], customer: null, billDiscount: 0, taxInclusive: false, paymentMethod: "", paidAmount: "", customValue: "" };

function load() {
  try { return { ...EMPTY, ...(JSON.parse(localStorage.getItem(KEY) || "{}")) }; }
  catch { return { ...EMPTY }; }
}

export function BillingProvider({ children }) {
  const [state, setState] = useState(load);

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(state)); }, [state]);

  const update = (patch) => setState((s) => ({ ...s, ...patch }));
  const reset = () => setState({ ...EMPTY });

  return <BillingContext.Provider value={{ state, update, reset, setState }}>{children}</BillingContext.Provider>;
}

export function useBilling() {
  return useContext(BillingContext);
}
